import ReturnDetail from "./ReturnDetail";

export default ReturnDetail;
